(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './androidx-navigationevent-navigationevent.js', './kotlin-kotlin-stdlib.js', './androidx-compose-runtime-runtime.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./androidx-navigationevent-navigationevent.js'), require('./kotlin-kotlin-stdlib.js'), require('./androidx-compose-runtime-runtime.js'));
  else {
    if (typeof globalThis['androidx-navigationevent-navigationevent'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-backhandler'. Its dependency 'androidx-navigationevent-navigationevent' was not found. Please, check whether 'androidx-navigationevent-navigationevent' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-backhandler'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-backhandler'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-backhandler'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-backhandler'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-backhandler'.");
    }
    globalThis['compose-multiplatform-core-compose-ui-ui-backhandler'] = factory(typeof globalThis['compose-multiplatform-core-compose-ui-ui-backhandler'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-ui-ui-backhandler'], globalThis['androidx-navigationevent-navigationevent'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-compose-runtime-runtime']);
  }
}(function (_, kotlin_androidx_navigationevent_navigationevent, kotlin_kotlin, kotlin_androidx_compose_runtime_runtime) {
  'use strict';
  //region block: imports
  var NavigationEventHandler = kotlin_androidx_navigationevent_navigationevent.$_$.a;
  var NavigationEventHandler_init_$Init$ = kotlin_androidx_navigationevent_navigationevent.$_$.h;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var NavigationEventInfo = kotlin_androidx_navigationevent_navigationevent.$_$.b;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var get_currentCompositeKeyHashCode = kotlin_androidx_compose_runtime_runtime.$_$.l1;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var DisposableEffect = kotlin_androidx_compose_runtime_runtime.$_$.p;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var staticCompositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.l2;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(BackEventHandler, 'BackEventHandler', VOID, NavigationEventHandler);
  initMetadataForClass(BackEventHandlerInfo, 'BackEventHandlerInfo', VOID, NavigationEventInfo);
  initMetadataForClass(BackHandler$$inlined$cache$1$1);
  //endregion
  var androidx_compose_ui_backhandler_BackEventCompat$stable;
  var androidx_compose_ui_backhandler_BackEventHandler$stable;
  function BackEventHandler(compositeKey, enabled, onBack) {
    NavigationEventHandler_init_$Init$(new BackEventHandlerInfo(compositeKey), enabled, this);
    this.n8s_1 = onBack;
  }
  protoOf(BackEventHandler).w8o = function () {
    this.n8s_1();
  };
  function BackEventHandlerInfo(compositeKey) {
    NavigationEventInfo.call(this);
    this.o8s_1 = compositeKey;
  }
  protoOf(BackEventHandlerInfo).toString = function () {
    return 'BackEventHandlerInfo(compositeKey=' + this.o8s_1.toString() + ')';
  };
  protoOf(BackEventHandlerInfo).hashCode = function () {
    return this.o8s_1.hashCode();
  };
  protoOf(BackEventHandlerInfo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BackEventHandlerInfo))
      return false;
    if (!equalsLong(this.o8s_1, other.o8s_1))
      return false;
    return true;
  };
  function get_LocalCompatNavigationEventDispatcherOwner() {
    _init_properties_BackHandler_jb_kt__15k5tp();
    return LocalCompatNavigationEventDispatcherOwner;
  }
  var LocalCompatNavigationEventDispatcherOwner;
  function BackHandler(enabled, onBack, $composer, $changed, $default) {
    _init_properties_BackHandler_jb_kt__15k5tp();
    var enabled_0 = {_v: enabled};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(760097452);
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.l31(enabled_0._v) ? 4 : 2);
    if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.q31(onBack) ? 32 : 16);
    if ($composer_0.r31(!(($dirty & 19) === 18), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        enabled_0._v = true;
      }
      var tmp0 = get_LocalCompatNavigationEventDispatcherOwner();
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var $composer_1 = $composer_0;
      var tmp0_elvis_lhs = $composer_1.u31(tmp0);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.error' call
        var message = 'No NavigationEventDispatcher was provided via LocalCompatNavigationEventDispatcherOwner';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var owner = tmp;
      var dispatcher = owner.p8s();
      var compositeKey = get_currentCompositeKeyHashCode($composer_0, 0);
      var tmp0_0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!($composer_0.o31(compositeKey) | ($dirty & 112) === 32);
      // Inline function 'kotlin.let' call
      var it = tmp0_0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance().f30_1) {
        var value = new BackEventHandler(compositeKey, enabled_0._v, onBack);
        tmp0_0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var handler = tmp_0;
      handler.m8o(enabled_0._v);
      var tmp0_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid_0 = !!($composer_0.q31(dispatcher) | $composer_0.q31(handler));
      // Inline function 'kotlin.let' call
      var it_0 = tmp0_1.i31();
      var tmp_1;
      if (invalid_0 || it_0 === Companion_getInstance().f30_1) {
        var value_0 = BackHandler$lambda(dispatcher, handler);
        tmp0_1.j31(value_0);
        tmp_1 = value_0;
      } else {
        tmp_1 = it_0;
      }
      var tmp$ret$6 = tmp_1;
      DisposableEffect(dispatcher, handler, tmp$ret$6, $composer_0, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(BackHandler$lambda_0(enabled_0, onBack, $changed, $default));
    }
  }
  function LocalCompatNavigationEventDispatcherOwner$lambda() {
    _init_properties_BackHandler_jb_kt__15k5tp();
    return null;
  }
  function BackHandler$$inlined$cache$1$1($handler) {
    this.q8s_1 = $handler;
  }
  protoOf(BackHandler$$inlined$cache$1$1).s1d = function () {
    this.q8s_1.l4();
  };
  function BackHandler$lambda($dispatcher, $handler) {
    return function ($this$DisposableEffect) {
      $dispatcher.w8n($handler);
      // Inline function 'androidx.compose.runtime.DisposableEffectScope.onDispose' call
      return new BackHandler$$inlined$cache$1$1($handler);
    };
  }
  function BackHandler$lambda_0($enabled, $onBack, $$changed, $$default) {
    return function ($composer, $force) {
      BackHandler($enabled._v, $onBack, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  var properties_initialized_BackHandler_jb_kt_6brqwr;
  function _init_properties_BackHandler_jb_kt__15k5tp() {
    if (!properties_initialized_BackHandler_jb_kt_6brqwr) {
      properties_initialized_BackHandler_jb_kt_6brqwr = true;
      LocalCompatNavigationEventDispatcherOwner = staticCompositionLocalOf(LocalCompatNavigationEventDispatcherOwner$lambda);
    }
  }
  var androidx_compose_ui_backhandler_ProgressBackEventHandler$stable;
  //region block: init
  androidx_compose_ui_backhandler_BackEventCompat$stable = 0;
  androidx_compose_ui_backhandler_BackEventHandler$stable = 8;
  androidx_compose_ui_backhandler_ProgressBackEventHandler$stable = 8;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = BackHandler;
  _.$_$.b = get_LocalCompatNavigationEventDispatcherOwner;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-ui-ui-backhandler.js.map
